import React, {forwardRef} from 'react';

export interface BoxProps {
  className?: string;
  children?: React.ReactNode;
  direction?: 'horizontal' | 'vertical';
  align?: 'left' | 'right' | 'center' | 'space-between';
  verticalAlign?: 'top' | 'middle' | 'bottom';
  width?: string;
  gap?: string;
  onClick?: () => void;
  styles?: React.CSSProperties;
}

const alignVariants: Record<string, string> = {
  left: 'justify-start',
  right: 'justify-end',
  center: 'justify-center',
  'space-between': 'justify-between',
};

const verticalAlignVariants: Record<string, string> = {
  top: 'items-start',
  middle: 'items-center',
  bottom: 'items-end',
};

const Box = forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      className,
      children,
      direction = 'horizontal',
      align = 'left',
      verticalAlign = 'top',
      width = 'w-full',
      gap = 'gap-1.5',
      onClick,
      styles,
    },
    ref,
  ) => {
    const style = [
      direction == 'horizontal' ? 'flex-row' : 'flex-col',
      alignVariants[align],
      verticalAlignVariants[verticalAlign],
      width,
      gap,
      className,
    ].join(' ');

    return (
      <div
        ref={ref}
        onClick={onClick}
        className={`flex ${style}`}
        style={styles}>
        {children}
      </div>
    );
  },
);

Box.displayName = 'Box';

export default Box;
